import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/services/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component( {
  selector: 'ngx-app-calculate',
  templateUrl: './calculate.component.html',
  styleUrls: [ './calculate.component.scss' ],
} )
export class CalculateComponent implements OnInit {

  submitted: boolean;
  pageForm: FormGroup;
  total: string;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private commonService: CommonService,
  ) {
    this.createForm();
  }

  get f() {
    return this.pageForm.controls;
  }

  ngOnInit(): void {
  }

  presentToast( message, type ) {
    switch ( type ) {
      case 'success':
        this.toastr.success( message );
        break;
      case 'warning':
        this.toastr.warning( message );
        break;

      default:
        this.toastr.error( message );
        break;
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if ( this.pageForm.valid ) {
      this.commonService.calculator( this.pageForm.value ).subscribe( response => {
        this.total = `$${response.calculated.real_price}`;
      } );
    }
  }

  private createForm(): void {
    this.pageForm = this.formBuilder.group( {
      weight: [ '', [ Validators.required ] ],
    } );
  }

}
